import React, { useEffect, useMemo, useState } from "react";
import dropdown_icon from '../Components/Assets/dropdown_icon.png'
import Item from "../Components/Item/Item";
import { Link } from "react-router-dom";
import { useLocation, useParams } from "react-router-dom";
import { backend_url } from "../App";
import men_banner from "../Components/Assets/banner_mens.png";
import women_banner from "../Components/Assets/banner_women.png";
import kid_banner from "../Components/Assets/banner_kids.png";
import { getCategories } from "../common/api/api";
import { getActiveCategories, getAllowedCategorySlugs } from "../common/categoryTree";

const DEFAULT_BANNERS = {
  laptops: men_banner,
  mobiles: women_banner,
  accessories: kid_banner,
};

const ShopCategory = (props) => {

  const [allproducts, setAllProducts] = useState([]);
  const [categories, setCategories] = useState([]);
  const location = useLocation();
  const { categorySlug: routeCategorySlug } = useParams();

  const fetchInfo = () => {
    fetch(`${backend_url}/allproducts`)
      .then((res) => res.json())
      .then((data) => setAllProducts(data))
  };

  useEffect(() => { fetchInfo(); }, []);

  useEffect(() => {
    getCategories()
      .then((data) => setCategories(getActiveCategories(data)))
      .catch(() => setCategories([]));
  }, []);

  const params = new URLSearchParams(location.search);
  const activeCategorySlug = String(routeCategorySlug || props.category || "").toLowerCase();
  const keyword = (params.get("sub") || params.get("brand") || params.get("type") || "").toLowerCase();
  const activeCategory = useMemo(
    () => categories.find((cat) => String(cat.slug).toLowerCase() === activeCategorySlug),
    [categories, activeCategorySlug]
  );
  const allowedCategories = useMemo(
    () => getAllowedCategorySlugs(categories, activeCategorySlug),
    [categories, activeCategorySlug]
  );
  const bannerImage = props.banner || DEFAULT_BANNERS[activeCategorySlug] || women_banner;

  const filteredProducts = allproducts.filter((item) => {
    const itemCategory = String(item.category || "").toLowerCase();
    const categoryMatch = allowedCategories.includes(itemCategory);
    if (!categoryMatch) return false;
    if (!keyword) return true;
    const haystack = `${item.name || ""} ${item.description || ""} ${itemCategory}`.toLowerCase();
    return haystack.includes(keyword);
  });

  return (
    <div className="min-h-screen">
      {/* Banner */}
      <div className="relative overflow-hidden">
        <img src={bannerImage} className="block mx-auto my-8 w-4/5 rounded-2xl opacity-90 max-[1280px]:w-[90%] max-[800px]:w-[95%] max-[800px]:my-5" alt={activeCategory?.name || activeCategorySlug || "category"} />
      </div>

      {/* Sort bar */}
      <div className="flex justify-between items-center mx-[8%] mb-6 text-sm max-[1280px]:mx-[5%]">
        <p className="text-[#6b7a8d]">
          <span className="font-bold text-[#00d4ff]">{filteredProducts.length} products</span>
          {activeCategory?.name && <span className="text-[#a0aec0]"> in {activeCategory.name}</span>}
          {' '}found {keyword && <span className="text-[#a0aec0]">for &quot;{keyword}&quot;</span>}
        </p>
        <div className="flex items-center gap-2 px-4 py-2.5 rounded-xl border border-white/[0.1] bg-white/[0.04] text-[#a0aec0] cursor-pointer hover:border-[rgba(0,212,255,0.3)] transition-colors text-xs font-semibold">
          Sort by <img src={dropdown_icon} alt="" className="w-3 ml-1 brightness-0 invert opacity-50" />
        </div>
      </div>

      {/* Products grid */}
      <div className="w-[90%] max-w-[1400px] mx-auto flex flex-wrap justify-center gap-6">
        {filteredProducts.map((item, i) => (
          <Item id={item.id} key={i} name={item.name} image={item.image} new_price={item.new_price} old_price={item.old_price} />
        ))}
        {filteredProducts.length === 0 && (
          <div className="w-full text-center py-24">
            <div className="text-6xl mb-4">🔍</div>
            <h3 className="text-white text-2xl font-bold mb-2">No products found</h3>
            <p className="text-[#6b7a8d]">Try a different search or browse all products.</p>
          </div>
        )}
      </div>

      {/* Load more */}
      {filteredProducts.length > 0 && (
        <div className="flex justify-center my-16 max-[800px]:my-10">
          <Link to='/' className="flex items-center h-12 px-8 rounded-xl bg-[rgba(0,212,255,0.08)] border border-[rgba(0,212,255,0.25)] text-[#00d4ff] text-sm font-semibold cursor-pointer transition-all hover:bg-[rgba(0,212,255,0.16)] hover:border-[rgba(0,212,255,0.5)]">
            Explore More →
          </Link>
        </div>
      )}
    </div>
  );
};

export default ShopCategory;
